import LanguageManagementComponent from 'components/desktop/StandingData/Language/Management/LanguageManagementComponent';

const LanguageManagementContainer = () => {
	const renderContent = () => {
		return (
			<main className="containter">
				<LanguageManagementComponent />
			</main>
		);
	};

	return <>{renderContent()}</>;
};

export default LanguageManagementContainer;
